import React, { FC, ReactNode } from "react";

import Header from "../../components/Header";
import Page from "../../components/Page";
import { HELP_DOCS_DEFAULT_BASE_URL } from "../../slices/help_docs";
import { getRouteFormProperty } from "../../slices/routes";
import { useSelector } from "../../store";

type EditWrapperProps = {
  children: ReactNode;
  routeId: string | undefined;
};

export const EditWrapper: FC<EditWrapperProps> = ({ routeId, children }) => {
  const name = useSelector(getRouteFormProperty("name", "")) as string;
  const originatorId = useSelector(
    getRouteFormProperty("originatorId", ""),
  ) as string;
  const title = routeId ? `Editing Route ${name || ""}` : `Create Route`;

  return (
    <Page title={title}>
      <Header
        breadcrumbs={true}
        title={title}
        helpUrl={HELP_DOCS_DEFAULT_BASE_URL + "/docs/capabilities/routing"}
        videoId="-wAKnj_cY-E"
        originatorId={originatorId}
      />
      {children}
    </Page>
  );
};
